<template>
  <div class="work-detail2 edit-item" v-if="editingData">

    <div class="head"><b>業務内容（詳細）</b></div>
    <div class="data">
      <input-textarea v-model="editingData.work_detail2" type="text"
        :error="getError(editingData, 'work_detail2')" :disabled="disabled"></input-textarea>
      <p class="current-data pre" v-if="currentData?.work_detail2">{{ currentData.work_detail2 }}</p>
    </div>
    
  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup() {
    const { getError } = useForm();

    return {
      getError
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

</style>
